module.exports = __webpack_public_path__ + "img/1492479210.a3c37249.jpg";